import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=606e8150&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=ts"
export * from "./Metrics.vue?vue&type=script&lang=ts"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=606e8150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606e8150",
  null
  
)

export default component.exports